<template>
  <div>
    <section-title content="Id. Participantes" :has-line="true" />
    <custom-callout
      :key="index"
      v-for="(item, index) in participants"
      class="mt-4 custom-callout"
      :has-toggle="false"
    >
      <div class="row bg-gray p-4 m-0">
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Nombre del Participante
          </div>
          <div class="color-black font-16">
            {{ item.name }}
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Puesto:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.position.name }}
          </div>
        </div>
        <div
          v-if="displayEvaluatorCheck(item.position.id)"
          class="col-md-2 col-12 col-spacing student-spacing"
        >
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Equipo Evaluador:
          </div>
          <div class="color-black font-16 font-weight-normal">
            <checkbox
              class="my-2"
              :disabled-bg-color="'bg-dark-gray'"
              :checked-bg-color="'bg-success'"
              :icon="'fal fa-check'"
              v-model="participants[index].evaluator"
              :disabled="isReadOnly"
              @input="() => modelChanged()"
            />
          </div>
        </div>
        <div
          v-if="item.fromAppointment"
          class="col-sm col-12 col-spacing student-spacing"
        >
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Asistencia:
          </div>
          <div class="color-black font-16 font-weight-normal">
            <custom-radio-group
              :name="`attendance` + index"
              v-model="participants[index].attendance"
              :options="radioButtonsOptions"
              is-inline
              :is-disabled="isReadOnly"
              class="ml-n3"
              @input="modelChanged()"
            />
          </div>
        </div>
        <div
          v-if="!item.fromAppointment && !isReadOnly"
          class="col-sm text-right"
        >
          <action-button
            id="modal-btn-cancelar"
            variant="outline-danger"
            i="fas fa-times-circle"
            @click="removeParticipant(index)"
          ></action-button>
        </div>
      </div>
    </custom-callout>
    <div v-if="displayAddNewParticipantSection">
      <validation-observer ref="participantValidator">
        <custom-callout class="mt-4 custom-callout" :has-toggle="false">
          <div class="row bg-gray p-4 m-0">
            <div class="col-md-3 col-12 col-spacing student-spacing">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Nombre del Participante(s):
              </div>
              <div class="color-black font-16 mt-2 font-weight-bold">
                <validation-provider
                  mode="eager"
                  :rules="'required'"
                  v-slot="{ errors }"
                >
                  <custom-input
                    placeholder="Nombre del Participante"
                    type="text"
                    v-model="addNewParticipantModel.name"
                    :error="errors[0]"
                    :custom-error-msg="
                      'El nombre del participante es requerido'
                    "
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-sm col-12 col-spacing student-spacing">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Puesto:
              </div>
              <div class="color-black font-16 mt-2 font-weight-bold">
                <validation-provider :rules="'required'" v-slot="{ errors }">
                  <custom-drop-down
                    v-model="addNewParticipantModel.position"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="positionList"
                    :custom-error-msg="
                      'El puesto del participante es requerido'
                    "
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-sm text-right mt-3">
              <action-button
                id="modal-btn-cancelar"
                variant="outline-danger mr-3"
                i="fas fa-times-circle"
                @click="cancelAddParticipant"
              >
                Cancelar
              </action-button>
              <action-button
                id="modal-btn-cancelar"
                variant="success"
                i="fas fa-file-plus"
                @click="() => addParticipant()"
              >
                Añadir
              </action-button>
            </div>
          </div>
        </custom-callout>
      </validation-observer>
    </div>
    <div class="col-12 mt-2">
      <error
        v-if="evaluatorTeamError"
        :message="
          'El Equipo Evaluador debe contar con la participación de un Especialista en Asistencia Tecnológica y un Maestro CERT AT.'
        "
        variant="no-border"
      />
    </div>
    <div class="col-12 mt-2">
      <error
        v-if="attendanceError"
        :message="'Es requerido documentar la asistencia de los participantes.'"
        variant="no-border"
      />
    </div>
    <div
      v-if="!displayAddNewParticipantSection && !isReadOnly"
      class="mt-4 text-right"
    >
      <action-button
        id="modal-btn-cancelar"
        variant="success"
        i="fas fa-file-plus"
        @click="() => (displayAddNewParticipantSection = true)"
      >
        Añadir Participante
      </action-button>
    </div>
  </div>
</template>

<script>
const POSITIONSTYPES = {
  MAESTROAT: 1924,
  ESPECIALISTACERTAT: 1923,
  ESPECIALISTAAT: 850,
};
import CustomCallout from 'custom-callout';
import CustomRadioGroup from '@/components/common/CustomRadio';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import SectionTitle from 'SectionTitle';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import Checkbox from 'CheckBox';
import Error from 'custom-error';
export default {
  name: 'Participants',
  components: {
    CustomCallout,
    ValidationObserver,
    ValidationProvider,
    CustomRadioGroup,
    ActionButton,
    CustomInput,
    CustomDropDown,
    SectionTitle,
    Checkbox,
    Error,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    referralId: {
      type: Number,
      default: () => 0,
    },
    isAppraisal: {
      type: Boolean,
      default: () => false,
    },
    isValidation: {
      type: Boolean,
      default: () => false,
    },
    isEquipmentRelatedServiceRequest: {
      type: Boolean,
      default: () => false,
    },
    evaluatorTeamError: {
      type: Boolean,
      default: () => true,
    },
    attendanceError: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      attendanceAnswers: [],
      displayAddNewParticipantSection: false,
      radioButtonsOptions: [
        { label: 'Si', value: true },
        { label: 'No', value: false },
      ],
      addNewParticipantModel: { name: null, position: null, evaluator: false },
      participants: [],
      positions: [],
    };
  },
  computed: {
    positionList() {
      if (
        this.isAppraisal ||
        this.isValidation ||
        this.isEquipmentRelatedServiceRequest
      ) {
        return this.positions.filter(
          (x) =>
            x.id == POSITIONSTYPES.ESPECIALISTACERTAT ||
            x.id == POSITIONSTYPES.ESPECIALISTAAT ||
            x.id == POSITIONSTYPES.MAESTROAT
        );
      } else {
        return this.positions;
      }
    },
  },
  async mounted() {
    await this.getStudentInfoParticipantList();
    await this.getParticipants();
  },
  methods: {
    displayEvaluatorCheck(positionId) {
      return (
        positionId == POSITIONSTYPES.ESPECIALISTACERTAT ||
        positionId == POSITIONSTYPES.ESPECIALISTAAT ||
        positionId == POSITIONSTYPES.MAESTROAT
      );
    },
    removeParticipant(index) {
      this.participants.splice(index, 1);
      this.modelChanged();
    },
    async addParticipant() {
      const isValid = await this.$refs.participantValidator.validate();
      if (!isValid) return false;
      this.participants.push({
        name: this.addNewParticipantModel.name,
        position: this.addNewParticipantModel.position,
        evaluator: false,
        attendance: null,
        fromAppointment: false,
      });
      this.displayAddNewParticipantSection = false;
      this.addNewParticipantModel = {
        name: null,
        position: null,
        evaluator: false,
      };
      this.modelChanged();
    },
    async getParticipants() {
      const { data } = await referralAndEquipmentsservice.getATParticipants(
        this.referralId
      );
      this.participants = data.map((item) => {
        return {
          name: item.fullName,
          position: {
            id: item.positionStatusCode,
            name: item.positionStatusName,
          },
          evaluator: item.isEvaluationTeam,
          attendance: item.assistance,
          fromAppointment: item.isAppointmentParticipant,
          participantId: item.participantId,
        };
      });
      this.modelChanged();
    },
    async getStudentInfoParticipantList() {
      const {
        data,
      } = await referralAndEquipmentsservice.getStudentInfoParticipantList(
        this.isAppraisal,
        this.isValidation
      );
      this.positions = data;
    },
    modelChanged() {
      const data = this.participants.map((item) => {
        return {
          fullName: item.name,
          positionStatusCode: item.position.id,
          positionStatusName: item.position.name,
          isEvaluationTeam: item.evaluator,
          isAppointmentParticipant: item.fromAppointment,
          participantId: item.participantId,
          assistance: item.attendance,
        };
      });
      this.$emit('input', data);
    },
    cancelAddParticipant() {
      this.displayAddNewParticipantSection = false;
    },
  },
};
</script>

<style scoped>
.custom-control-input,
.custom-control-label {
  cursor: pointer;
}
.custom-control-input:checked.custom-control-input:checked:disabled
  ~ .custom-control-label::before {
  color: #fff;
  border-color: #2db782;
  background-color: #2db782;
}
.custom-control-input.invalid ~ .custom-control-label::before {
  background-color: #f7d7da;
  border-color: #e85c5c;
}

.sucess-icon {
  font-size: 19px;
  position: absolute;
  top: 9px;
  right: 7px;
  color: #3f5b60;
  margin-right: 0.2rem;
}
.sucess-icon:before {
  content: '\f058';
  color: #2db782;
}
div.invalid:not(input) {
  color: #e85c5c;
}
.form-control-icon-normal {
  position: absolute;
  top: 9px;
  right: 10px;
  color: #3f5b60;
  margin-right: 0.2rem;
}
.icon-invalid {
  color: #e85c5c;
}

.custom-error i {
  float: left;
  margin-top: 15px;
  margin-right: 10px;
  color: #e85c5c;
}

.custom-control-label.invalid::before {
  border-color: #e85c5c;
  border-width: 2px;
  background: #f7d7da;
}
</style>
